module.exports = __webpack_public_path__ + "media/static/icons/icon-arrow-down-9f220c1b2cd45a56d692115f4c841f99.svg";